import { render } from "./RegistraGaranzia.vue?vue&type=template&id=3eb205f5"
import script from "./RegistraGaranzia.vue?vue&type=script&lang=js"
export * from "./RegistraGaranzia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__